import { MDBDatatable, MDBIcon, MDBInput } from 'mdb-react-ui-kit';
import React, { useEffect, useRef, useState } from 'react';
import { customSearch, useAutoFocusSearchAfterLoads } from '../../CustomSearchUtil/CustomSearch';
import UIConstant from '../../../apiclients/UIConstant';

function LocNineOODevices(props) {
    const [devicesList, setDevicesList] = useState([]);


    const [searchValue, setsearchValue] = useState("");
    const [filteredRows, setFilteredRows] = useState([]);
    const [rowdata, setRowData] = useState([]);
    const [dataLoaded, setDataLoaded] = useState(false);
    const searchRef = useRef(null);
   useAutoFocusSearchAfterLoads(dataLoaded,setDataLoaded,searchRef,props.isActive)

    useEffect(() => {
        if (props.devicesList && props.devicesList.length > 0) {
            setDevicesList(props.devicesList);
        }

    }, [props.devicesList]);

    const redirectionToSettings = (device) => {
        console.log(device.deviceObj.mac_address)
        const { mac_address, device_UUID } = device.deviceObj;
        if (mac_address) {
            window.open(`/ipphoneadd?mac_address=${mac_address}`);
        } else {
            window.open(`/manualdevicesettings?device=${device_UUID}`);
        }
    };

    useEffect(() => {
    let proccessdRows = [];
    devicesList && devicesList.map((device) => {

        proccessdRows.push({
            deviceObj: device ?? "",
            phone_name: device.ph_name ?? "",
            user: device.user ?? "",
            extension: device.extension ?? "",
            designation: device.designation ?? "",
            model: device.model ??  "",
            mac_address: device.mac_address ?? "",
            device_UUID: device.device_UUID ?? "",
            online: (
                <>
                    <div className="ml-2">
                        <MDBIcon fas icon="circle" className="green" width="15px" />
                    </div>
                </>
            ),

        });
    });
    setRowData(proccessdRows);
    setFilteredRows(proccessdRows)
    setDataLoaded(true)
},[devicesList,props.isActive])

    const actionData3 = {
        columns: [
            { label: "Phone Name", field: "phone_name" },
            { label: "User", field: "user" },
            { label: "Extension", field: "extension" },
            { label: "Designation", field: "designation" },
            { label: "Model", field: "model" },
            { label: "MAC Address", field: "mac_address" },
            { label: "Online", field: "online", sort: false },
        ],
        rows: rowdata,
    };

  
const handleManualSearch = (searchValue) => {
    setsearchValue(searchValue);
    const filteredUsers = customSearch(rowdata, searchValue, UIConstant.LOCATION_NINEONE_DEVICES);
    setFilteredRows(filteredUsers);
};

    return (
        <><div className='locationDevices'>
            <div className='actionbar'></div>
            <div className='mb-2 mt-2 position-relative w-auto'>
                <MDBInput ref={searchRef} label="Search" value={searchValue} onChange={(e) => handleManualSearch(e.target.value)} />
                <MDBIcon fas icon="search" className='MDBDatatable-Search' />
            </div>
            <MDBDatatable
                key={searchValue}
                entries={50}
                sortField="Phone Name"
                maxHeight='calc(100vh - 390px)'
                fixedHeader
                data={{
                    ...actionData3,
                    rows: filteredRows
                }}
                className="mt-2"
                onRowClick={(data)=>redirectionToSettings(data)}
            />

        </div>
        </>
    )
}

export default LocNineOODevices
